var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("section-title", {
        staticStyle: { "margin-top": "40px" },
        attrs: { content: "Documentos de Dispensa", "has-line": true }
      }),
      _c(
        "validation-observer",
        { ref: "dispenseDocumentsRef", attrs: { novalidate: "", tag: "form" } },
        _vm._l(_vm.innerExemptionFiles, function(exemptionFile, i) {
          return _c(
            "div",
            { key: i },
            [
              _c(
                "callout",
                { attrs: { "class-main": "mb-2 py-3", "has-toggle": false } },
                [
                  _c(
                    "div",
                    { staticClass: "col-12 d-flex justify-content-between" },
                    [
                      _c("div", [
                        _c("span", { staticClass: "exemption-file__title" }, [
                          _vm._v("Documento")
                        ]),
                        _c("p", [_vm._v(_vm._s(exemptionFile.name))])
                      ]),
                      _c(
                        "div",
                        [
                          _c("CustomFileInput", {
                            attrs: {
                              accept: ".pdf",
                              "add-text": "Presione aquí para añadir Documento",
                              "attachment-id": exemptionFile.fileId,
                              "display-style": "normal",
                              name: exemptionFile.fileName,
                              "on-download": () => {}
                            },
                            model: {
                              value: exemptionFile.file,
                              callback: function($$v) {
                                _vm.$set(exemptionFile, "file", $$v)
                              },
                              expression: "exemptionFile.file"
                            }
                          })
                        ],
                        1
                      )
                    ]
                  )
                ]
              ),
              _vm.showExemptionError &&
              exemptionFile.required &&
              !exemptionFile.file &&
              !exemptionFile.fileId
                ? _c("error", {
                    staticClass: "mb-3",
                    attrs: {
                      message: "El documento es requerido.",
                      variant: "no-border"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        }),
        0
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }